import {
  CompaniesService, UsersService,
} from '@/services';
import CompanyParser from '@/parsers/company';

const store = {
  namespaced: true,
  state: {
    users: null,
    brokers: [],
    isCompanyLoading: false,
    isUsersLoading: false,
    isLoadingBrokers: false,
  },
  mutations: {
    SET_USERS(state, value) {
      state.users = value;
    },

    SET_BROKERS(state, value) {
      state.brokers = value;
    },

    SET_USERS_LOADING(state, value) {
      state.isUsersLoading = value;
    },

    SET_BROKERS_LOADING(state, value) {
      state.isLoadingBrokers = value;
    },

    SET_COMPANY_LOADING(state, value) {
      state.isCompanyLoading = value;
    },
  },
  actions: {
    async fetchUsers({ commit }, companyId) {
      commit('SET_USERS_LOADING', true);

      try {
        const users = await UsersService.fetchUserProfilesByCompany(companyId);
        commit('SET_USERS', users);
      } catch (err) {
        console.log(err);
      }

      commit('SET_USERS_LOADING', false);
    },

    async fetchBrokers({ commit }, { companyId, teamSlug }) {
      commit('SET_BROKERS_LOADING', true);

      try {
        const brokers = await UsersService.fetchCompanyBrokers({ companyId, teamSlug });
        commit('SET_BROKERS', brokers);
      } catch (err) {
        console.log(err);
      }

      commit('SET_BROKERS_LOADING', false);
    },

    async updateCompanyInfo({ dispatch, commit }, data) {
      dispatch('setCompanyLoading', true);
      try {
        await CompaniesService.updateCompanyInfo({ ...data, companyId: data.companyId });

        commit('global/SET_COMPANY', CompanyParser.parseToAPI(data), { root: true });

        commit('global/SET_NOTIFICATION', {
          variant: 'success',
          content: 'Dados da empresa atualizados com sucesso',
          title: 'Sucesso!',
        }, { root: true });
      } catch (err) {
        console.log(err);

        commit('global/SET_NOTIFICATION', {
          variant: 'danger',
          content: 'Não foi possível atualizar os dados da empresa',
          title: 'Ops! Encontramos um problema',
        }, { root: true });
      }

      dispatch('setCompanyLoading', false);
    },

    setCompanyLoading({ commit }, value) {
      commit('SET_COMPANY_LOADING', value);
    },
  },
};

export default store;
